import React from 'react';
import GestionAbstract from '../../components/forms/gestion-abstract';
import IPointEauType from '../../models/IPointEauType';
import Guid from '../../models/Guid';
import IBaseModel from '../../models/IBaseModel';

interface IGestionProps {
  isModeSelection?: boolean;
}

class PointEauType extends IBaseModel implements IPointEauType {
  idPointEauType: Guid = Guid.empty;
}

export default function GestionPointEauType({ isModeSelection }: IGestionProps) {
  return (
    <GestionAbstract isModeSelection={isModeSelection} path="PointEauType" model={PointEauType} />
  );
}